var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import toast from 'react-hot-toast';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
import { useFinderToFinderHandler } from '@data/dragAndDrop/finderHandlers';
import { useTagSidebarToPivotWidgetHandler, useTagSidebarToFinderHandler, useTagSidebarToModelCustomColumnHandler, useTagSidebarToSingleValueWidgetHandler, useTagSidebarToTagSidebarHandler, } from '@data/dragAndDrop/tagSidebarHandlers';
import { useSingleValueWidgetToEmptyHandler, useSingleValueWidgetToSingleValueWidgetHandler, } from '@data/dragAndDrop/singleValueWidgetHandlers';
import { usePivotWidgetToDataEditorWidgetHandler, usePivotWidgetToEmptyHandler, } from '@data/dragAndDrop/pivotWidgetHandlers';
import { DroppableType, parseDraggableId, parseDroppableId, } from '@data/dragAndDrop/types';
import { useLanguage } from './LanguageProvider';
export default function DragAndDropWrapper(_a) {
    var _b, _c, _d, _e, _f;
    var children = _a.children;
    var L = useLanguage().L;
    var finderToFinderHandler = useFinderToFinderHandler();
    var tagSidebarToFinderHandler = useTagSidebarToFinderHandler();
    var tagSidebarToTagSidebarHandler = useTagSidebarToTagSidebarHandler();
    var tagSidebarToSingleValueWidgetHandler = useTagSidebarToSingleValueWidgetHandler();
    var tagSidebarToDataEditorWidgetHandler = useTagSidebarToPivotWidgetHandler();
    var tagSidebarToModelCustomColumnHandler = useTagSidebarToModelCustomColumnHandler();
    var singleValueWidgetToEmptyHandler = useSingleValueWidgetToEmptyHandler();
    var singleValueWidgetToSingleValueWidgetHandler = useSingleValueWidgetToSingleValueWidgetHandler();
    var dataEditorWidgetToEmptyHandler = usePivotWidgetToEmptyHandler();
    var dataEditorWidgetToDataEditorWidgetHandler = usePivotWidgetToDataEditorWidgetHandler();
    // 1st level is source (droppable from which the user is dragging)
    // 2nd level is target (droppable where the item was dragged to)
    var handlerMap = (_b = {},
        _b[DroppableType.Finder] = (_c = {},
            _c[DroppableType.Finder] = finderToFinderHandler,
            _c),
        _b[DroppableType.TagSidebar] = (_d = {},
            _d[DroppableType.Finder] = tagSidebarToFinderHandler,
            _d[DroppableType.TagSidebar] = tagSidebarToTagSidebarHandler,
            _d[DroppableType.SingleValueWidget] = tagSidebarToSingleValueWidgetHandler,
            _d[DroppableType.PivotWidget] = tagSidebarToDataEditorWidgetHandler,
            _d[DroppableType.ModelCustomColumn] = tagSidebarToModelCustomColumnHandler,
            _d),
        _b[DroppableType.SingleValueWidget] = (_e = {},
            _e[DroppableType.Empty] = singleValueWidgetToEmptyHandler,
            _e[DroppableType.SingleValueWidget] = singleValueWidgetToSingleValueWidgetHandler,
            _e),
        _b[DroppableType.PivotWidget] = (_f = {},
            _f[DroppableType.Empty] = dataEditorWidgetToEmptyHandler,
            _f[DroppableType.PivotWidget] = dataEditorWidgetToDataEditorWidgetHandler,
            _f),
        _b);
    function onDragEnd(result) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var sourceInfo, draggableInfo, combineDraggableInfo, targetInfo, dropHandler, dropHandlerResult;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (result.reason === 'CANCEL') {
                            // do nothing if drag was cancelled
                            return [2 /*return*/];
                        }
                        startGlobalLoading();
                        sourceInfo = parseDroppableId(result.source.droppableId);
                        draggableInfo = parseDraggableId(result.draggableId);
                        combineDraggableInfo = result.combine ? parseDraggableId(result.combine.draggableId) : undefined;
                        targetInfo = result.combine
                            ? parseDroppableId(result.combine.droppableId)
                            : result.destination
                                ? parseDroppableId(result.destination.droppableId)
                                : { type: DroppableType.Empty };
                        dropHandler = (_a = handlerMap[sourceInfo.type]) === null || _a === void 0 ? void 0 : _a[targetInfo.type];
                        if (!(dropHandler !== undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, dropHandler(sourceInfo, targetInfo, draggableInfo, combineDraggableInfo, (_b = result.destination) === null || _b === void 0 ? void 0 : _b.index)];
                    case 1:
                        dropHandlerResult = _c.sent();
                        // if result came back with a message, display it
                        if (dropHandlerResult.message !== undefined) {
                            toast[dropHandlerResult.status](L(dropHandlerResult.message));
                        }
                        _c.label = 2;
                    case 2:
                        stopGlobalLoading();
                        return [2 /*return*/];
                }
            });
        });
    }
    return React.createElement(DragDropContext, { onDragEnd: onDragEnd }, children);
}
